module.exports = __webpack_public_path__ + "public/SiteIcons/editInfoTipIcon.svg?f0a815b8";